<template>
  <v-col cols="12" xl="6">
    <v-container fluid>
      <v-row no-gutters>
        <div class="stats-title">
          <h3>{{ $t(title) }}</h3>
          <v-tooltip
            v-if="tooltip"
            bottom
            :max-width="400"
            nudge-right="100%"
            transition="fade-transition"
            content-class="tooltip-content">
            <template v-slot:activator="{on, attrs}">
              <v-icon class="fa-light fa-circle-info click" color="tertiary" dense v-on="on" v-bind="attrs" />
            </template>
            <span v-html="$t(tooltip)"></span>
          </v-tooltip>
        </div>
      </v-row>
      <v-row>
        <v-col cols="12" md="6" lg="4">
          <CardTrend
            :loading="loading"
            :title1="$t('honda.dashboard.stats.registrations.registrations')"
            :value1="data.hondaPlus"
            :percent="data.hondaPlusYoy"
            :year="data.year" />
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <CardTrend
            :loading="loading"
            :title1="$t('honda.dashboard.stats.registrations.with-mapit')"
            :value1="data.mapitPerc"
            :title2="$t('honda.dashboard.stats.registrations.with-insurance')"
            :value2="data.insurancePerc"
            :title3="$t('honda.dashboard.stats.registrations.with-financing')"
            :value3="data.financedPerc"
            :year="data.year" />
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <CardGauge
            :loading="loading"
            :title="$t('honda.dashboard.stats.registrations.hp-go')"
            :current="data.hondaPlusGo"
            :percent="data.hondaPlusGoPerc" />
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script lang="ts">
import {defineComponent} from '@vue/composition-api'

import CardGauge from '@/components/metrics/CardGauge.vue'
import CardTrend from '@/components/metrics/CardTrend.vue'

export default defineComponent({
  name: 'StatsRegistrations',
  components: {
    CardGauge,
    CardTrend,
  },
  props: {
    loading: {
      type: Boolean,
      required: false,
    },
    title: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      required: false,
    },
    data: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
})
</script>
